const cloud = { x: 265, y: 360 };
const apple = { x: 590, y: 450 };
const tree = { x: 600, y: 680, leafHeight: 20 };
const diagonal = { x: 170, y: 230, width: 20, height: 60 };

const normalHolds = {
  floor: { x: -9, y: 760, width: 999, height: 20, type: "rect", color: "#999" },
  start: { x: 410, y: 560, width: 95, height: 20, type: "rect", color: "blue" },
  top: {
    x: 490,
    y: 100,
    radius: 30,
    type: "circle",
    color: "gold",
    text: "top",
  },
  a0: {
    x: tree.x,
    y: tree.y,
    width: 20,
    height: 80,
    type: "rect",
    color: "#744700",
  },
  a1: {
    x: tree.x - 40,
    y: tree.y,
    width: 100,
    height: tree.leafHeight,
    type: "rect",
    color: "green",
  },
  a2: {
    x: tree.x - 30,
    y: tree.y - tree.leafHeight * 1,
    width: 80,
    height: tree.leafHeight,
    type: "rect",
    color: "green",
  },
  a3: {
    x: tree.x - 20,
    y: tree.y - tree.leafHeight * 2,
    width: 60,
    height: tree.leafHeight,
    type: "rect",
    color: "green",
  },
  a4: {
    x: tree.x - 10,
    y: tree.y - tree.leafHeight * 3,
    width: 40,
    height: tree.leafHeight,
    type: "rect",
    color: "green",
  },
  a5: {
    x: tree.x,
    y: tree.y - tree.leafHeight * 4,
    width: 20,
    height: tree.leafHeight,
    type: "rect",
    color: "green",
  },
  b1: { x: 450, y: 710, width: 30, height: 20, type: "rect", color: "navy" },
  b2: { x: 280, y: 590, width: 30, height: 20, type: "rect", color: "navy" },
  b3: { x: 200, y: 500, width: 30, height: 20, type: "rect", color: "navy" },
  b4: { x: 120, y: 400, width: 30, height: 20, type: "rect", color: "navy" },
  h1: { x: 360, y: 680, width: 20, height: 20, type: "rect", color: "skyblue" },
  h2: { x: 380, y: 500, width: 20, height: 20, type: "rect", color: "skyblue" },
  h3: { x: 380, y: 250, width: 20, height: 20, type: "rect", color: "skyblue" },
  h4: { x: 700, y: 600, width: 20, height: 20, type: "rect", color: "skyblue" },
  p1: {
    x: diagonal.x,
    y: diagonal.y,
    width: diagonal.width,
    height: diagonal.height,
    type: "rect",
    color: "purple",
  },
  p2: {
    x: diagonal.x + 50,
    y: diagonal.y - 60,
    width: diagonal.width,
    height: diagonal.height,
    type: "rect",
    color: "purple",
  },
  p3: {
    x: diagonal.x + 100,
    y: diagonal.y - 120,
    width: diagonal.width,
    height: diagonal.height,
    type: "rect",
    color: "purple",
  },
  p4: {
    x: diagonal.x + 150,
    y: diagonal.y - 180,
    width: diagonal.width,
    height: diagonal.height,
    type: "rect",
    color: "purple",
  },
  c0: { x: 530, y: 350, radius: 10, type: "star", color: "goldenrod" },
  c00: { x: 540, y: 230, radius: 10, type: "star", color: "goldenrod" },
  c1: { x: apple.x, y: apple.y, radius: 23, type: "circle", color: "darkred" },
  c2: {
    x: apple.x + 15,
    y: apple.y - 22,
    width: 15,
    height: 5,
    type: "ellipse",
    color: "#8fce00",
  },
  c3: {
    x: apple.x,
    y: apple.y - 33,
    width: 5,
    height: 15,
    type: "rect",
    color: "#744700",
  },
  d1: {
    x: cloud.x + 15,
    y: cloud.y + 45,
    width: 15,
    height: 70,
    type: "rect",
    color: "#6495ed",
  },
  d2: {
    x: cloud.x + 50,
    y: cloud.y + 85,
    width: 15,
    height: 70,
    type: "rect",
    color: "#6495ed",
  },
  f0: { x: cloud.x, y: cloud.y, radius: 20, type: "circle", color: "#fff" },
  f1: {
    x: cloud.x + 30,
    y: cloud.y - 5,
    radius: 25,
    type: "circle",
    color: "#fff",
  },
  f2: {
    x: cloud.x + 55,
    y: cloud.y,
    radius: 20,
    type: "circle",
    color: "#fff",
  },
  f3: {
    x: cloud.x + 80,
    y: cloud.y + 2,
    radius: 15,
    type: "circle",
    color: "#fff",
  },
  g1: {
    x: 800,
    y: 550,
    width: 30,
    height: 210,
    type: "rect",
    color: "mediumseagreen",
  },
  g2: {
    x: 800,
    y: 535,
    width: 30,
    height: 10,
    type: "rect",
    color: "mediumseagreen",
  },
  g3: {
    x: 800,
    y: 330,
    width: 30,
    height: 200,
    type: "rect",
    color: "mediumseagreen",
  },
  g4: {
    x: 775,
    y: 410,
    width: 17,
    height: 10,
    type: "ellipse",
    color: "mediumseagreen",
  },
  g40: {
    x: 855,
    y: 480,
    width: 17,
    height: 10,
    type: "ellipse",
    color: "mediumseagreen",
  },
  g5: {
    x: 800,
    y: 315,
    width: 30,
    height: 10,
    type: "rect",
    color: "mediumseagreen",
  },
  g6: {
    x: 800,
    y: 110,
    width: 30,
    height: 200,
    type: "rect",
    color: "mediumseagreen",
  },
  g7: {
    x: 670,
    y: 70,
    width: 20,
    height: 20,
    type: "rect",
    color: "mediumseagreen",
  },
  g8: {
    x: 670,
    y: 200,
    width: 20,
    height: 20,
    type: "rect",
    color: "mediumseagreen",
  },
};

export default normalHolds;
